export class ResponseModel {
  errors: string[];
  success: boolean;
}
